import { Deferred } from '../../../webrtc/utils/deferred';
import {
  RealtimeMessageType,
  type CallStartMessagePayload,
} from '../../../features/realtime/realtime.types';
import { CommonRealtimeService } from './commonRealtime.service';
import { type RealtimeEventCbCancel } from '@doxyme/realtime';

export class PatientRealtimeService extends CommonRealtimeService {
  private incomingCallSubscription: RealtimeEventCbCancel | undefined;

  private readonly incomingCallNegotiationSubscription:
    | RealtimeEventCbCancel
    | undefined;

  async receiveCallDetails(): Promise<CallStartMessagePayload> {
    const incomingCall = new Deferred<CallStartMessagePayload>();

    this.incomingCallSubscription = this.on(
      RealtimeMessageType.CallStart,
      (message) => {
        incomingCall.resolve(message.payload as CallStartMessagePayload);
      },
      { once: true },
    );

    return incomingCall.promise;
  }
}
